import script from "./ReportReasonFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportReasonFormView.vue?vue&type=script&setup=true&lang=js"

import "./ReportReasonFormView.vue?vue&type=style&index=0&id=17862d60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17862d60"]])

export default __exports__